<script lang="ts">
  interface Props {
    size?: number;
    [key: string]: any;
  }

  let { size = 32, ...rest }: Props = $props();
</script>

<svg
  width={size}
  height={size}
  viewBox="0 0 32 32"
  fill="none"
  shape-rendering="crispEdges"
  xmlns="http://www.w3.org/2000/svg"
  {...rest}
>
  <rect x="2" y="22" width="2" height="2" fill="currentColor" />
  <rect x="4" y="20" width="2" height="2" fill="currentColor" />
  <rect x="6" y="20" width="2" height="2" fill="currentColor" />
  <rect x="6" y="18" width="6" height="2" fill="currentColor" />
  <rect x="8" y="16" width="8" height="2" fill="currentColor" />
  <rect x="10" y="14" width="18" height="2" fill="currentColor" />
  <rect x="12" y="10" width="2" height="2" fill="currentColor" />
  <rect x="12" y="12" width="2" height="2" fill="currentColor" />
  <rect x="16" y="2" width="2" height="2" fill="currentColor" />
  <rect x="18" y="2" width="2" height="2" fill="currentColor" />
  <rect x="20" y="2" width="2" height="2" fill="currentColor" />
  <rect x="22" y="2" width="2" height="2" fill="currentColor" />
  <rect x="24" y="2" width="2" height="2" fill="currentColor" />
  <rect x="26" y="4" width="2" height="2" fill="currentColor" />
  <rect x="24" y="4" width="2" height="2" fill="currentColor" />
  <rect x="18" y="4" width="6" height="4" fill="currentColor" />
  <rect x="28" y="6" width="2" height="2" fill="currentColor" />
  <rect x="28" y="8" width="2" height="2" fill="currentColor" />
  <rect x="28" y="10" width="2" height="2" fill="currentColor" />
  <rect x="28" y="12" width="2" height="2" fill="currentColor" />
  <rect x="24" y="6" width="4" height="8" fill="currentColor" />
  <rect x="28" y="14" width="2" height="2" fill="currentColor" />
  <rect x="26" y="16" width="2" height="2" fill="currentColor" />
  <rect x="24" y="18" width="2" height="2" fill="currentColor" />
  <rect x="22" y="18" width="2" height="2" fill="currentColor" />
  <rect x="20" y="18" width="2" height="2" fill="currentColor" />
  <rect x="16" y="18" width="4" height="2" fill="currentColor" />
  <rect x="18" y="12" width="2" height="2" fill="currentColor" />
  <rect x="18" y="8" width="2" height="2" fill="currentColor" />
  <rect x="22" y="12" width="2" height="2" fill="currentColor" />
  <rect x="22" y="8" width="2" height="2" fill="currentColor" />
  <rect x="16" y="16" width="10" height="2" fill="currentColor" />
  <rect x="10" y="20" width="2" height="2" fill="currentColor" />
  <rect x="8" y="20" width="2" height="6" fill="currentColor" />
  <rect x="12" y="18" width="2" height="4" fill="currentColor" />
  <rect x="6" y="28" width="2" height="2" fill="currentColor" />
  <rect x="4" y="28" width="2" height="2" fill="currentColor" />
  <rect x="2" y="28" width="2" height="2" fill="currentColor" />
  <rect x="2" y="26" width="2" height="2" fill="currentColor" />
  <rect x="2" y="24" width="2" height="2" fill="currentColor" />
  <rect x="10" y="22" width="2" height="6" fill="currentColor" />
  <rect x="14" y="18" width="2" height="6" fill="currentColor" />
  <rect x="12" y="8" width="2" height="2" fill="currentColor" />
  <rect x="12" y="6" width="2" height="2" fill="currentColor" />
  <rect x="14" y="4" width="4" height="10" fill="currentColor" />
  <rect x="4" y="22" width="2" height="6" fill="currentColor" />
  <rect x="6" y="22" width="2" height="6" fill="currentColor" />
</svg>
